export const ENTITY = 'ORGANIZATION_CATEGORY';

export const ORGANIZATION_CATEGORY_TYPE = {
   MINISTRY_AND_OFFICE: 'MINISTRY_AND_OFFICE',
   GOVERNMENT: 'GOVERNMENT',
   FUNCTION_NAME: 'FUNCTION_NAME',
   FUNCTION_TASK: 'FUNCTION_TASK',
}